import { Fragment } from 'react';

import { CraftsmanPropertyHeader } from '../../../components/CraftsmanPropertyHeader/CraftsmanPropertyHeader.tsx';
import { registerTkv2ReferenceProperty } from '../../../components/ReferenceBar/registerTkv2ReferenceProperty.ts';
import { useTkv2ReferenceBarEvents } from '../../../components/ReferenceBar/useTkv2ReferenceBarEvents.ts';
import { getReferenceProperty } from '../../utils/getReferenceProperty.ts';
import { TdGap } from './TdGap.tsx';
import { PairedCostAdjustmentSummaryProps } from './types.ts';

export const PairedCostAdjustmentSummaryTablePropertyHeader = ({
  isSimplifiedMode: showSummaryColumn,
  compSequence,
}: PairedCostAdjustmentSummaryProps) => {
  const refbar = (col: string) =>
    registerTkv2ReferenceProperty(getReferenceProperty(col, compSequence));

  const tkv2ReferenceBarEvents = useTkv2ReferenceBarEvents();

  return (
    <tr>
      <th
        className="valuation-header"
        colSpan={showSummaryColumn ? 3 : 2}
        {...refbar('subject')}
        {...tkv2ReferenceBarEvents}
      >
        <CraftsmanPropertyHeader propertyId="subject" />
      </th>
      {compSequence.map((compID, idx) => (
        <Fragment key={`header-${compID}`}>
          <TdGap isSticky={idx === 0} />
          <th
            colSpan={2}
            className="valuation-header"
            {...refbar(compID)}
            {...tkv2ReferenceBarEvents}
          >
            <CraftsmanPropertyHeader propertyId={compID} />
          </th>
        </Fragment>
      ))}
    </tr>
  );
};
